import { render, staticRenderFns } from "./loading-full-component.vue?vue&type=template&id=4977d433&lang=html"
import script from "./loading-full-component.vue?vue&type=script&lang=js"
export * from "./loading-full-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports